import useTrait from './useTrait';

export const useInflightTracker = () => {
    const inflightCalls = useTrait<string[]>([]);

    const addApiCall = (url: string) => {
        const currentInflightCalls = inflightCalls.get();
        currentInflightCalls.push(url);
        inflightCalls.set([...new Set(currentInflightCalls)]);
    };

    const isAlreadyInflight = (url: string) => {
        const currentInflightCalls = inflightCalls.get();
        return currentInflightCalls.includes(url);
    };

    const removeApiCall = (url: string) => {
        let currentInflightCalls = inflightCalls.get();
        currentInflightCalls = currentInflightCalls.filter(thisUrl => thisUrl !== url);
        inflightCalls.set([...new Set(currentInflightCalls)]);
    };

    return {
        addApiCall,
        isAlreadyInflight,
        removeApiCall,
    };
};
